import { render, staticRenderFns } from "./contact-tag-table.vue?vue&type=template&id=765a035e&scoped=true&"
import script from "./contact-tag-table.ts?vue&type=script&lang=ts&"
export * from "./contact-tag-table.ts?vue&type=script&lang=ts&"
import style0 from "./contact-tag-table.scss?vue&type=style&index=0&id=765a035e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a035e",
  null
  
)

export default component.exports